import React from 'react'
import { ReportContextValue } from './ReportContext.d'

const ReportContext = React.createContext<ReportContextValue>({ pdfSlicers: {} })

export { ReportContext }
